<template>
	<div class="form-section-container">
		<div class="action">
			<small><span>Select active languages</span></small><br>
			<typeahead
				:url="`${API_BASE_URL}/languages?limit=10&filter[0][name]=Name&filter[0][type]=contains`"
				:min="2"
				dataKey="data._embedded.languages"
				filterKey="filter[0][term]"
				autocomplete="off"
				:clearOnSelect="true"
				@typeaheadSelect="add($event)"
				:displayPhrase="(item) => `${item.Name} (${item.Code})`"
				:cleanApi="true"
				placeholder="type a language and select from the list"
				:inputStyles="{'minWidth':'20rem'}"
				></typeahead>
			<!-- <input type="text"
				v-model="val"
				@keydown.enter.prevent="add(val)"
				> -->
			<!-- &nbsp; <button type="button" class="btn btn-green" @click.prevent="add(val)">&plus; add</button> -->
			<!-- <button class="btn btn-grey" @click="no">Cancel</button> -->
			<div class="dashed-container">
				<label
					:key="item.Id"
					v-for="item in tempItems"
					:title="defaultInput === JSON.stringify(item) ? `selected as default language` : 'click to set as default language'">
					<input type="radio" name="project.language.default" v-model="defaultInput" :value="JSON.stringify(item)" style="" />
					<span>{{ item.Name }}</span> <font-awesome-icon
								@click.prevent="rem(item)"
								title="remove"
								:icon="['fas', 'times']"></font-awesome-icon>
					<input type="hidden" :name="inputName" :value="JSON.stringify(item)">
				</label>
			</div>
		</div>
	</div>
</template>
<script>
import Typeahead from '@/components/shared/Typeahead'
export default {
	components: {
		'typeahead': Typeahead
	},
	props: {
		'inputName': {
			type: String,
			required: true
		},
		'inputValue': {
			type: [String, Number],
			required: true
		},
		'tempParentItems': {
			type: Array,
			required: false,
			default: () => []
		},
		'defaultItem': {
			type: String,
			required: false,
			default: ''
		}
	},
	data () {
		return {
			val: '',
			tempItems: [],
			defaultInput: null
		}
	},
	computed: {
	},
	methods: {
		add (data) {
			this.tempItems.push(data)
			this.$nextTick(() => {
				this.val = ''
			})
		},
		rem (item) {
			this.tempItems.splice(this.tempItems.indexOf(item), 1)
		}
	},
	watch: {
		'tempParentItems': {
			handler: function (n) {
				if (n) {
					n.forEach(i => {
						this.tempItems.push(JSON.parse(i))
					})
				}
			},
			immediate: true
		},
		'defaultItem': {
			handler: function (n) {
				if (n) {
					this.defaultInput = n
				}
			},
			immediate: true
		}
	}
}
</script>
<style lang="scss" scoped>
.dashed-container {
	border: 2px dashed #39424f;
    padding: 10px;
    margin: 10px 10px 10px 0;
	label {
		font-size: 14px;
		background: #3d4857;
		padding: 0.25em 0.5em;
		margin-right: 0.5em;
		border-radius: 3px;
        input[type="radio"] {
            vertical-align: -2px;
            margin-right:10px;
        }
		> svg {
			margin-left: 10px;
			padding:0.25em 0 0;
			transition:transform 0.2s ease-out;
			&:hover {
				color:red;
				transform:scale(1.25);
			}
		}
	}
}
</style>
